/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { BulkUpdateItemComponentListItemDto } from '@gh/builder-shared-data';
import { ID } from '@gh/common-shared-data';

export type BulkUpdateItemComponentListItem = BulkUpdateItemComponentListItemDto;

export interface ItemComponentList {
  id: ID;
  component: boolean;
}

export function itemComponentSplitByGroups(itemComponent: ItemComponentList[]): { items: ID[]; components: ID[] } {
  const items: ID[] = [];
  const components: ID[] = [];
  itemComponent.forEach((item) => {
    if (item.component) {
      components.push(item.id);
    } else {
      items.push(item.id);
    }
  });

  return { items, components };
}

export const getBulkUpdateItemComponentId = (item: BulkUpdateItemComponentListItem) => item.id;
